import axios from 'axios';
//import { getData } from '../Stores/Store';
import Constant from './Constant'
const config = require('../config')
/**
 * @class
 * Network is base class for creating all webservice/API call for entire project. This class have all comom headers and request setting required for IntelliCoach App.
 * @use  Extend / inherit Network Class and user function postRequest , getRequest to cretae your basic get and post service calls.
 * @function getRequest use to create GET request.
 * @function postRequest use to create POST request.
 */

/**
 * Comman request Header
 */
const reqHeader = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Headers': 'Content-Type',
};
/**
 * Create Global axios instance for creating GET , POST request.
 */
const axiosInstanceGlobal = axios.create({});
axiosInstanceGlobal.headers = reqHeader;
axiosInstanceGlobal.timeout = 20000;
axiosInstanceGlobal.headers.AppVersion = '1.0.0';
 axiosInstanceGlobal.headers.platForm = 'ios';
// axiosInstanceGlobal.headers.xsrfCookieName = 'XSRF-TOKEN';
// axiosInstanceGlobal.headers.xsrfHeaderName = 'X-XSRF-TOKEN';

// axiosInstanceGlobal.interceptors.request.use(async reqConfig => {
//   // reqConfig.headers.interCeptorHeader = 'InterCeptor';
//   var token = await getData('authToken')
//   token = JSON.parse(token);
//   if (token === undefined || token === null) {
//     token = '';
//   }
//   reqConfig.headers.Authorization = token;
//   return reqConfig;
// });

export default class NetworkBase {
  /**
   * @function
   * getRequest Function is used to create get request.
   * @param {sting} getURL pass GET  request.
   * @param {object} getParams pass parameters for GET  request.
   *
   * @returns Promise use .then for handling response and .catch for handling erros.
   */

resetHeader()
{
  axiosInstanceGlobal.headers = reqHeader;
 axiosInstanceGlobal.timeout = 20000;
 axiosInstanceGlobal.headers.authorization = Constant.FTK;
 axiosInstanceGlobal.headers.AppVersion = '1.0.0';
 axiosInstanceGlobal.headers.platForm = 'ios';


}

  getRequest(getURL, getParams) {
    this.resetHeader()

    return new Promise(function(resolve, reject) {

      axiosInstanceGlobal
        .get(getURL, {headers: {
          'authorization': Constant.FTK
        }})
        .then(function(response) {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          } else {
            let error = new Error(response.data.message);
            console.log('get response error', error);
            reject(error);
          }
        })
        .catch(function(error) {
          console.log('catched get error', error);
          // self.postGrayLogRequest(getURL,getParams,error);
          reject(error);
        });
    });
  }

  patchRequest(patchURL, postData) {
    this.resetHeader()

    return new Promise(function(resolve, reject) {

      axiosInstanceGlobal
        .patch(patchURL, postData, {headers: {
          'authorization': Constant.FTK
        }})
        .then(function(response) {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          } else {
            let error = new Error(response.data.message);
            console.log('get response error', error);
            reject(error);
          }
        })
        .catch(function(error) {
          console.log('catched get error', error);
          // self.postGrayLogRequest(getURL,getParams,error);
          reject(error);
        });
    });
  }
  /**
   * @function
   * postRequest Function is used to create get request.
   * @param {string} postURL
   * @param {Object} postData
   * @returns Promise use .then for handling response and .catch for handling erros.
   */
  postRequest(postURL, postData) {
    console.log('post header', axiosInstanceGlobal.headers);
    this.resetHeader()
    return new Promise(function(resolve, reject) {
      axiosInstanceGlobal
        .post(postURL, postData,{headers: {
          'authorization': Constant.FTK
        }})
        .then(function(response) {
          console.log('post Response', response);
          if (response.status === 200) {
            resolve(response.data);
          } else {
            let error = new Error(response.data.message);
            reject(error);
          }
        })
        .catch(function(error) {
          // self.postGrayLogRequest(postURL,postData,error);
          reject(error);
        });
    });
  }





  /**
   * @function
   * putRequest Function is used to create get request.
   * @param {string} postURL
   * @param {Object} postData
   * @returns Promise use .then for handling response and .catch for handling erros.
   */
  putRequest(postURL, postData) {
    this.resetHeader()
    return new Promise(function(resolve, reject) {
      axiosInstanceGlobal
        .put(postURL, postData,{headers: {
          'authorization': Constant.FTK
        }})
        .then(function(response) {
          console.log('post Response', response);
          if (response.status === 200) {
            resolve(response.data);
          } else {
            console.log('error put Response', response);

            let error = new Error(response.data.message);
             // self.postGrayLogRequest(postURL,postData,error);
            reject(error);
          }
        })
        .catch(function(error) {
          console.log('catched post error', error);
          // self.postGrayLogRequest(postURL,postData,error);
          reject(error);
        });
    });
  }

  /**
   * @function
   * putRequest Function is used to create get request.
   * @param {string} deleteURL
   * @param {Object} deleteData
   * @returns Promise use .then for handling response and .catch for handling erros.
   */
  deleteRequest(deleteURL, deleteData) {
    this.resetHeader()
    return new Promise(function(resolve, reject) {
      console.warn("inside Promise", deleteURL, deleteData)
      axiosInstanceGlobal
        .delete(deleteURL, {headers: {
          'authorization': Constant.FTK
        }})
        .then(function(response) {
          console.log('delete Response', response);
          if (response.status === 200) {
            resolve(response.data);
          } else {
            console.warn('error delete Response', response);

            let error = new Error(response.data.message);
            // self.postGrayLogRequest(deleteURL,deleteData,error);
            reject(error);
          }
        })
        .catch(function(error) {
          console.warn('catched delete error', error);
          // self.postGrayLogRequest(deleteURL,deleteData,error);
          reject(error);
        });
    });
  }


  /**
   * @function
   * postGrayLogRequestPrameter Function is used to create post request.
   * @param {string} postURL
   * @param {Object} postData
   * @returns Promise use .then for handling response and .catch for handling erros.
   */
  

  loggerStageLiveAPI(){
    if(Constant.CURRENT_ENVIRONMENT === 'stage'){
      return 'https://stagefitapi.fcintelli.tech/api/';
      }
      else{
        return 'https://fitjunior.firstcryintelli.com/api/';
      }
  }

  apibasepath() {
    // return 'https://stagetotsapi.fcintelli.tech/api/';
    return config.baseurl;
   
  }
}
